import api from '@/api'
import Cookies from 'js-cookie'

const BOOKING_KEY = "BOOKING_KEY"

export default {
    state: ()=> ({
        shoppingCarts: [],
        shoppingCartCount: 0,
        rowShoppingCartCount: 0,
        hpShoppingCartCount: 0,
        bookingKey: Cookies.get(BOOKING_KEY),
        bookingLists: [],
        // 预订流程锁定的订单
        order: {
            bookings: [],
            shorex: {},
            payShorexCount: 0,
            visaWarning: {},
            departureCode: '',
            isSevenDayNrpCruise: false,
            isFortyEightHoursNrpCruise: false
        }
    }),
    actions: {
        GET_SHOPPING_CART_COUNT: async ({ commit }, userToken) => {
            const { success, data, errMsg } = await api.booking.getShoppingCartCount({
                type: 0,
                userName: userToken
            })
            if (!success) console.error(errMsg)
            commit('GET_SHOPPING_CART_COUNT', data)
        },
        GET_SHOPPING_CART: async ({ commit }, userToken) => {
            const { success, data, errMsg } = await api.booking.getShoppingCart({
                type: 0,
                userName: userToken
            })
            if (!success) console.error(errMsg)
            commit('GET_SHOPPING_CART', data)
        },
        SET_BOOKING_KEY: ( { commit }, bookingKey) => {
            commit('SET_BOOKING_KEY', bookingKey)
        }
    },
    mutations: {
        GET_SHOPPING_CART: (state, shoppingCarts) => {
            if (shoppingCarts.bookings) {
                state.shoppingCarts = shoppingCarts.bookings
                state.shoppingCartCount = shoppingCarts.bookings.length
                state.hpShoppingCartCount = shoppingCarts.homePortShoppingCartCount || 0
                state.rowShoppingCartCount = shoppingCarts.tuiShoppingCartCount || 0
            } else {
                state.shoppingCarts = []
                state.shoppingCartCount = 0
                state.hpShoppingCartCount = 0
                state.rowShoppingCartCount = 0
            }
        },
        GET_SHOPPING_CART_COUNT: (state, data) => {
            state.shoppingCartCount = data.count || 0
            state.hpShoppingCartCount = data.homePortShoppingCartCount || 0
            state.rowShoppingCartCount = data.tuiShoppingCartCount || 0
        },
        SET_BOOKING_KEY: (state, bookingKey) => {
            Cookies.set(BOOKING_KEY, bookingKey, { expires: 1 })
            state.bookingKey = bookingKey
        },
        SET_BOOKING_FUNNEL_ORDER: (state, order) => {
            state.order = order
        },
        SET_BOOKING_LIST: (state, bookingLists) => {
            state.bookingLists = bookingLists
        }
    }
  }